import libraryTypes from '../enums/libraryTypes'
import { isMobile } from '../device'
import isTouch from 'helpers/isTouch'

const isNotInLti = libraryType => libraryType === libraryTypes.REGULAR

const canDragAndDrop = libraryType => (isNotInLti(libraryType) && !isMobile && !isTouch())

const canShowSecondaryActions = libraryType => isNotInLti(libraryType)

export {
	canShowSecondaryActions,
	canDragAndDrop,
}
